import { types } from 'mobx-state-tree';


const HEATING_TYPES = {
    ELECTRIC_BASEBOARD: 'electric-baseboard',
    HOT_WATER: 'hot-water-heating',
    OTHER: 'other',
    GEOTHERMAL: 'geothermal',
    FIREPLACE: 'fireplace',
    PELLET_STOVE: 'pellet-stove',
    RADIANT: 'radiant',
    WOOD: 'wood',
    WOODSTOVE: 'woodstove',
    WOOD_FURNACE: 'wood-furnace',
    NONE: 'none',
    UNKNOWN: 'unknown',
    OIL: 'oil',
    FORCED_AIR: 'forced-air',
};

const HeatingTypeEnum = types.enumeration('HeatingType', Object.values(HEATING_TYPES));

export {
    HeatingTypeEnum,
};
export default HEATING_TYPES;
